var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpen20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "currentColor",
    transform: "translate(.8 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.993.5c.32 0 .627.127.853.354.414.413.976.646 1.561.646h5.909c.861 0 1.18.072 1.497.241.278.15.497.368.646.646.169.317.241.636.241 1.497h0V4.5h-15V2.581c0-.532.078-.888.241-1.194.15-.278.368-.497.646-.646C2.893.578 3.249.5 3.78.5h2.212z",
    id: "Rectangle",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.13 4.5c.414 0 .79.168 1.06.44.266.264.432.628.44 1.031h0l-.705 5.684c-.088.694-.17.945-.329 1.19-.136.21-.318.37-.543.479-.263.126-.523.176-1.222.176h0H3.569c-.7 0-.959-.05-1.222-.176a1.316 1.316 0 01-.543-.479c-.159-.245-.24-.496-.329-1.19h0L.782 6.19a1.498 1.498 0 011.27-1.673h0z",
    id: "Rectangle",
    fillOpacity: 0.2,
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen20);
export default __webpack_public_path__ + "static/media/folder-open-20.eb379770.svg";
export { ForwardRef as ReactComponent };